import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-background pt-20 pb-24 lg:pt-32 lg:pb-40">
      
      {/* Background Abstract Shapes */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full z-0 pointer-events-none">
        <div className="hidden lg:block absolute top-10 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] opacity-60" />
        <div className="hidden lg:block absolute bottom-0 left-0 w-[600px] h-[600px] bg-accent/5 rounded-full blur-[120px] opacity-50" />
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto space-y-8">
          
          <div className="inline-flex items-center space-x-2 px-3 py-1 bg-surface border border-border rounded-full shadow-sm mb-4">
            <span className="flex h-2 w-2 relative">
               <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
               <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            <span className="text-xs font-semibold text-text-secondary uppercase tracking-wider">Meet The Team</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-text-primary leading-[1.1]">
            Architecting the Future of <br className="hidden md:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accent">
              Work & Efficiency
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
            We are not just coders; we are process engineers. We believe that humans should do creative work, and robots should do the rest.
          </p>

          {/* Modern Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pt-8 max-w-3xl mx-auto">
            
            {/* Stat 1 */}
            <div className="flex flex-col items-center justify-center p-6 bg-card rounded-2xl border border-border shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="mb-3 p-3 bg-primary/10 rounded-xl text-primary">
                <Icon name="Briefcase" className="w-6 h-6 sm:w-8 sm:h-8" />
              </div>
              <span className="text-3xl font-bold text-text-primary">Proven</span>
              <span className="text-sm text-text-secondary">Industry Experience</span>
            </div>

            {/* Stat 2 */}
            <div className="flex flex-col items-center justify-center p-6 bg-card rounded-2xl border border-border shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="mb-3 p-3 bg-success/10 rounded-xl text-success">
                <Icon name="Users" className="w-6 h-6 sm:w-8 sm:h-8" />
              </div>
              <span className="text-3xl font-bold text-text-primary">Growing</span>
              <span className="text-sm text-text-secondary">Happy Clients</span>
            </div>

            {/* Stat 3 */}
            <div className="flex flex-col items-center justify-center p-6 bg-card rounded-2xl border border-border shadow-sm hover:shadow-lg transition-shadow duration-300">
                <div className="mb-3 p-3 bg-accent/10 rounded-xl text-accent">
                <Icon name="Clock" className="w-6 h-6 sm:w-8 sm:h-8" />
              </div>
              <span className="text-3xl font-bold text-text-primary">Many</span>
              <span className="text-sm text-text-secondary">Hours Saved</span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;